<ng-container *ngIf="isSmsEnabled; else smsDisabled">
	<obg-m-forgot-password-selection-container> </obg-m-forgot-password-selection-container>
	<ng-container *ngIf="!hideFooter">
		<obg-compact-footer></obg-compact-footer>
	</ng-container>
</ng-container>

<ng-template #smsDisabled>
	<obg-m-sm-forgot-password-email-container
		(close)="close.emit()"
		[customUsageEnabled]="customUsageEnabled"
		[hideFooter]="hideFooter"
	>
	</obg-m-sm-forgot-password-email-container>
</ng-template>
